import { render, staticRenderFns } from "./SubstituicaoPrestadoresFiltro.vue?vue&type=template&id=34335a84"
import script from "./SubstituicaoPrestadoresFiltro.vue?vue&type=script&lang=js"
export * from "./SubstituicaoPrestadoresFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports